<script>
import CompanyLicence from "../../components/CompanyLicence.vue";
import Stakeholders from "../usersStakeholders/components/stakeholders.vue";
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";

export default {
  components: {
    CompanyLicence,
    Stakeholders,
  },
  data() {
    return {
      loading: false,

      rootCompany: null,
      companies: [],

      addCompanyModal: false,
      addCompanyFromTableModal: false,
      companyInfoModal: false,

      companyToDelete: null,
      deleteCompanyModal: false,

      companyForPlanPopup: null,

      baseCompanyTypes: [
        {
          name: i18n.t('myCompanies.roles.god'),
          company_role: "god",
          level: 5
        },
        {
          name: i18n.t('myCompanies.roles.executive'),
          company_role: "executive",
          level: 4
        },
        {
          name: i18n.t('myCompanies.roles.white_label'),
          company_role: "white_label",
          level: 3
        },
        {
          name: i18n.t('myCompanies.roles.regular'),
          company_role: "regular_company",
          level: 2
        },
        {
          name: i18n.t('myCompanies.roles.supplier'),
          company_role: "supplier",
          level: 1
        }
      ],
      companyTypeToAdd: {
        name: "",
        company_role: "",
        level: "",
      },
      companyToAddUnder: null,
      companyToAddUnderFromTable: null,
      companyToLink: null,
      addCompanyStep: 1,
      addCompanyStepFromTable: 1,

      unlinkCompanyModal: false,
      companyToUnlink: null,

      allPlans: [],
      allSectors: [],

      countries: [],
      states: [],
      provinces: [],

      selectedCountry: null,
      selectedState: null,
      selectedProvince: null,

      companiesToAddUnder: [],
      companiesToLink: [],
      companyToAdd: {
        role_id: null,
        plan_id: null,
        company_name: null,
        company_fullname: null,
        website: null,
        company_email: null,
        company_phone: null,
        adress: null,
        description: null,
        sector_id: null,
        created_by: null,
        total_employee_number: null,
        facility_number: null,
        company_role: null,
      },

      companyIdForInfo: null,

      inviteSupplierEmail: "",
      inviteSupplierLanguage: "en",
      inviteSupplierInProgress: false,
    };
  },

  async mounted() {
    await this._getPlans();
    await this._getChildCompanies();
  },

  computed: {
    isAdminUser() {
      return this.$user.user_id == 81 && this.$user.role_id == 1;
    },

    companyID() {
      return this.$user.company_id;
    },

    myLevel() {
      if (!this.rootCompany) {
        return 1;
      }

      if (this.rootCompany.company_rank == "god") {
        return 5;
      } else if (this.rootCompany.company_rank == "executive") {
        return 4;
      } else if (this.rootCompany.company_rank == "white_label") {
        return 3;
      } else if (this.rootCompany.company_rank == "regular_company") {
        return 2;
      } else if (this.rootCompany.company_rank == "supplier") {
        return 1;
      } else {
        return null;
      }
    },

    shownCompanyTypes() { // calculates which companies can be added by user based on user company's authorization level
      return this.baseCompanyTypes.filter(item => item.level < this.myLevel);
    },

    showCompanyTypesFromTable() {
      if (!this.companyToAddUnderFromTable) {
        return this.baseCompanyTypes;
      } else {
        const type = this.baseCompanyTypes.find(x => x.company_role === this.companyToAddUnderFromTable.company_rank);
        if (type) {
          return this.baseCompanyTypes.filter(x => x.level < type.level);
        } else {
          return this.baseCompanyTypes;
        }
      }
    },

    companyTableHeaders() {
      if (this.$user.role_id === 1) {
        return [
          { key: 'company_name', label: i18n.t('myCompanies.company_table.name'), width: 3, centered: false },
          { key: 'company_role', label: i18n.t('myCompanies.company_table.role'), width: 2, centered: false },
          { key: 'plan_name', label: i18n.t('myCompanies.company_table.plan'), width: 2, centered: false },
          { key: 'licence_end_date', label: i18n.t('myCompanies.company_table.licence_end_date'), width: 2, centered: false },
          { key: 'created_on', label: i18n.t('myCompanies.company_table.register_date'), width: 2, centered: false },
          { key: 'users', label: i18n.t('myCompanies.company_table.info'), width: 1, centered: true },
          { key: 'link', label: i18n.t('myCompanies.company_table.add'), width: 1, centered: true },
          { key: 'unlink', label: i18n.t('myCompanies.company_table.unlink'), width: 1, centered: true },
          { key: 'delete', label: i18n.t('myCompanies.company_table.delete'), width: 1, centered: true },
        ];
      } else {
        return [
          { key: 'company_name', label: i18n.t('myCompanies.company_table.name'), width: 3, centered: false },
          { key: 'company_role', label: i18n.t('myCompanies.company_table.role'), width: 2, centered: false },
          { key: 'plan_name', label: i18n.t('myCompanies.company_table.plan'), width: 2, centered: false },
          { key: 'licence_end_date', label: i18n.t('myCompanies.company_table.licence_end_date'), width: 2, centered: false },
          { key: 'created_on', label: i18n.t('myCompanies.company_table.register_date'), width: 2, centered: false },
          { key: 'users', label: i18n.t('myCompanies.company_table.info'), width: 1, centered: true },
        ];
      }
    },

    userTableHeaders() {
      return [
        { label: i18n.t("userCompany.user.name"), width: 2, key: "firstname" },
        { label: i18n.t("userCompany.user.surname"), width: 2, key: "surname" },
        { label: i18n.t("userCompany.user.email"), width: 2, key: "email" },
        { label: i18n.t("userCompany.user.department"), width: 2, key: "user_department_name" },
        { label: i18n.t("userCompany.user.role"), width: 1, key: "role_name" },
        { label: i18n.t("userCompany.user.role"), width: 1, key: "created_on" },
      ];
    }
  },

  watch: {
    selectedCountry(val) {
      if (val != null) {
        this._getStatesByCountryId(val.add_country_id);
      }
    },
    selectedState(val) {
      if (val != null) {
        this._getProvincesByStateId(val.add_state_id);
      }
    },

    addCompanyModal(val) {
      if (val === true) {
        if (this.allSectors.length === 0) {
          this.getSectors();
        }

        if (this.countries.length === 0) {
          this._getCountries();
        }

        this.$refs.addCompanyPopup.openPopup();
      }
    },

    companyTypeToAdd(val) {
      if (val.company_role && val.company_role != '')
        this._getCompaniesToAddUnder();
    },

    addCompanyFromTableModal(val) {
      if (val === true) {
        this.$refs.linkCompanyPopup.openPopup();
      }
    },

    companyToAddUnderFromTable(val) {
      if (val) {
        this._getCompaniesBelowRank();
      }
    },

    unlinkCompanyModal(val) {
      if (val) {
        this.$refs.unlinkCompanyPopup.openPopup();
      }
    },

    companyInfoModal(val) {
      if (val) {
        this.$refs.companyInfoPopup.openPopup();
      }
    },

    deleteCompanyModal(val) {
      if (val) {
        this.$refs.deletePopup.openPopup();
      }
    }
  },

  methods: {
    ...mapActions('company', [
      'getChildCompanies',
      'getCompaniesToAddUnder',
      'getCompaniesBelowRank',
      "deleteCompanyCode",
      'linkCompany',
      'deleteCompany',
      'sendSupplierInvite',
      'sendExecutiveMail',
      'sendWhiteLabelMail',
      'sendRegularMail',
      'sendSupplierMail',
      'getCompanyLicence',
      'updateCompanyLicenceStatus',
      'getCountries',
      'getStatesByCountryId',
      'getProvincesByStateId',
      'getSector',
      'postCompany',
      'getPlans'
    ]),

    _getChildCompanies() {
      const params = {
        company_id: this.$user.company_id,
      };

      this.getChildCompanies(params)
        .then(res => {
          this.companies = res.data.companies.children;
          this.rootCompany = res.data.companies.parent;

          if (res.data.messageName.includes('no_related_companies')) {
            this.$notify('info', res.data.messageName);
            this.rootCompany.has_no_child = true;
          }
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        });
    },

    _getChildrenForCompany(parent) {
      if (parent.has_no_child) {
        return;
      }

      if (parent.company_id === this.$user.company_id) {
        this.rootCompany.is_open = !this.rootCompany.is_open;
        return;
      }

      if (parent.is_open === true) {
        parent.is_open = false;
        return;
      }

      const params = {
        company_id: parent.company_id,
      };

      this.getChildCompanies(params)
        .then(res => {
          if (res.data.companies.children.length > 0) {
            parent.children = res.data.companies.children;
            parent.is_open = true;
          } else {
            this.$notify('info', res.data.messageName);
            parent.has_no_child = true;
          }
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        });
    },

    _getCompaniesToAddUnder() {
      const params = {
        company_role: this.companyTypeToAdd.company_role
      }

      this.getCompaniesToAddUnder(params)
        .then(res => {
          this.companiesToAddUnder = res.data.companies;
        })
        .catch(() => {
          this.$notify('error', '', true);
        })
    },

    _getCompaniesBelowRank() {
      const params = {
        company_role: this.companyTypeToAdd.company_role
      }

      this.getCompaniesBelowRank(params)
        .then(res => {
          this.companiesToLink = res.data.companies;
        })
        .catch(() => {
          this.$notify('error', '', true);
        })
    },

    clickCompanyBtn(company, btn) {
      if (btn === 'link') {
        this.companyToAddUnderFromTable = company;
        this.addCompanyStepFromTable = 1;
        this.addCompanyFromTableModal = true;
      } else if (btn === 'unlink') {
        this.companyToUnlink = company;
        this.companyToUnlink['company_code'] = `${company.executive_code}-${company.white_label_code}-${company.regular_company_code}-${company.supplier_code}`;
        this.unlinkCompanyModal = true;
      } else if (btn === 'users') {
        this.companyIdForInfo = company.company_id;
        this.companyInfoModal = true;
      } else if (btn === 'delete') {
        this.companyToDelete = company;
        this.deleteCompanyModal = true;
      }
    },

    // get plans
    async _getPlans() {
      const params = {
        is_deleted: false
      };
      this.getPlans(params)
        .then(res => {
          this.allPlans = res.data;
        })
        .catch(({ response }) => {
          console.error(response.message);
        });
    },

    //get sector
    async getSectors() {
      // this.loading = true;
      this.allSectors = [];
      let params = {
        created_by: this.$user.user_id,
        is_deleted: false,
      };
      this.getSector(params)
        .then((res) => {
          res.data.forEach((element) => {
            this.allSectors.push(element);
          });
          // this.loading = false;
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },

    _getCountries() {
      this.getCountries()
        .then(res => {
          this.countries = res.data;

          if (this.selectedCountry) {
            this.selectedCountry = res.data.find(x => x.add_country_id == this.selectedCountry.add_country_id);
          }
        })
        .catch((err) => {
          console.error(err);
        })
    },

    _getStatesByCountryId(id) {
      this.getStatesByCountryId({ country_id: id })
        .then(res => {
          this.states = res.data;

          if (this.selectedState) {
            this.selectedState = res.data.find(x => x.add_state_id == this.selectedState.add_state_id);
          }
        })
        .catch((err) => {
          console.error(err);
        })
    },

    _getProvincesByStateId(id) {
      this.getProvincesByStateId({ state_id: id })
        .then(res => {
          this.provinces = res.data;

          if (this.selectedProvince) {
            this.selectedProvince = res.data.find(x => x.add_province_id == this.selectedProvince.add_province_id);
          }
        })
        .catch((err) => {
          console.error(err);
        })
    },

    // DATA //
    async createCompany() {
      let params = {
        created_by: this.$user.user_id,
        role_id: this.$user.role_id,
        plan_id: this.companyToAdd.plan_id,
        company_name: this.companyToAdd.company_name,
        company_fullname: this.companyToAdd.company_fullname,
        website: this.companyToAdd.website,
        company_email: this.companyToAdd.company_email,
        company_phone: this.companyToAdd.company_phone,
        adress: this.companyToAdd.adress,
        add_country_id: this.selectedCountry.add_country_id,
        add_state_id: this.selectedState.add_state_id,
        add_province_id: this.selectedProvince ? this.selectedProvince.add_province_id : null,
        description: this.companyToAdd.description,
        sector_id: this.companyToAdd.sector_id,
        total_employee_number: this.companyToAdd.total_employee_number,
        facility_number: this.companyToAdd.facility_number,
        company_role: this.companyTypeToAdd.company_role,
        executive_code: this.companyToAddUnder.executive_code,
        white_label_code: this.companyToAddUnder.white_label_code,
        regular_company_code: this.companyToAddUnder.regular_company_code,
      };
      await this.postCompany(params)
        .then(res => {
          this.$notify('success', 'Company created successfully.', true);
        })
        .catch(({ response }) => {
          this.$notify('error', 'Error creating company.', true);
        });
    },

    async _linkCompany() {
      let params = {
        company_id: this.companyToLink.company_id,
        created_by: this.$user.user_id,
      };

      if (this.companyTypeToAdd.company_role === 'white_label') {
        params.executive_code = this.companyToAddUnderFromTable.executive_code;
      } else if (this.companyTypeToAdd.company_role === 'regular_compay') {
        params.executive_code = this.companyToAddUnderFromTable.executive_code;
        params.white_label_code = this.companyToAddUnderFromTable.white_label_code;
      } else if (this.companyTypeToAdd.company_role === 'supplier') {
        params.executive_code = this.companyToAddUnderFromTable.executive_code;
        params.white_label_code = this.companyToAddUnderFromTable.white_label_code;
        params.regular_company_code = this.companyToAddUnderFromTable.regular_company_code;
      } else {
        console.error('Invalid company type to add!');
        return;
      }

      this.linkCompany(params)
        .then(res => {
          this.$notify('success', 'Linked the company successfully.', true);
        })
        .catch(({ response }) => {
          this.$notify('error', 'Error linking companies!', true);
        });
    },

    async unlinkCompany() {
      const params = {
        company_code: this.companyToUnlink.company_code
      };

      await this.deleteCompanyCode(params)
        .then(async (res) => {
          this.$notify('success', 'Successfully unlinked company.', true);
        })
        .catch(({ response }) => {
          this.$notify('error', 'Error unlinking company.', true);
        });
    },

    async setUnlinkCompany(bool, company) {
      this.unlinkCompanyModal = bool;
      if (bool == false) {
        this.companyToUnlink = null;
      } else {
        this.companyToUnlink = company;
      }
    },

    async _deleteCompany() {
      const params = {
        company_id: this.companyToDelete.company_id,
        user_id: this.$user.user_id
      }

      await this.deleteCompany(params)
        .then(res => {
          this.$notify("success", res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify("error", response.data.messageName);
        })
    },

    handleClickPlan(company) {
      this.companyForPlanPopup = company.company_id;
      this.$refs.companyLicencePopup.openPopup();
    },

    handleStepClick(direction) {
      if (direction === "right" && this.addCompanyStep !== 3) {
        this.addCompanyStep++;
      } else if (direction === "left" && this.addCompanyStep !== 1) {
        this.addCompanyStep--;
      }
    },

    handleStepClickFromTable(direction) {
      if (direction === "right" && this.addCompanyStepFromTable !== 2) {
        this.addCompanyStepFromTable++;
      } else if (direction === "left" && this.addCompanyStepFromTable !== 1) {
        this.addCompanyStepFromTable--;
      }
    },

    handlePlanChange(e, company) {
      if (company.company_id === e.company_id) {
        company.plan_id = e.plan_id;
        company.plan_name = e.plan_name;
        company.licence_status = e.licence_status;
      }

      if (company.company_id === this.rootCompany.company_id) {
        for (let idx = 0; idx < this.companies.length; idx++) {
          this.handlePlanChange(e, this.companies[idx]);
        }
      } else {
        if (company && company.children) {
          for (let idx = 0; idx < company.children.length; idx++) {
            this.handlePlanChange(e, company.children[idx]);
          }
        }
      }
    },

    openInviteSupplierPopup() {
      this.inviteSupplierEmail = "";
      this.inviteSupplierLanguage = "en";
      this.$refs.inviteSupplierPopup.openPopup();
    },

    async submitInviteSupplier() {
      if (!this.inviteSupplierEmail) {
        return;
      }
      this.inviteSupplierInProgress = true;
      try {
        const response = await this.sendSupplierInvite({
          target_email: this.inviteSupplierEmail,
          language: this.inviteSupplierLanguage,
        });
        this.$toast.open({
          message: this.$parseResMessage(response.data.messageName),
          type: "success",
          duration: 5000,
          dismissible: true,
        });
        this.$refs.inviteSupplierPopup.startHideProcess();
      } catch ({ response }) {
        this.$toast.open({
          message: this.$parseResMessage(response.data.messageName),
          type: "error",
          duration: 5000,
          dismissible: true,
        });
      } finally {
        this.inviteSupplierInProgress = false;
      }
    },

    resetAddCompanyModal() {
      this.addCompanyModal = false;
      this.addCompanyFromTableModal = false;
      this.addCompanyStep = 1;
      this.addCompanyStepFromTable = 1;

      this.companyTypeToAdd = {
        name: "",
        company_role: "",
        level: ""
      };
      this.companyToAddUnder = null,
        this.companyToAddUnderFromTable = null,

        this.companyToAdd = {
          role_id: null,
          plan_id: null,
          company_name: null,
          company_fullname: null,
          website: null,
          company_email: null,
          company_phone: null,
          adress: null,
          add_country_id: null,
          add_state_id: null,
          add_province_id: null,
          description: null,
          sector_id: null,
          created_by: null,
          total_employee_number: null,
          facility_number: null,
          company_role: null,
        }
    },
  },
};
</script>

<template>
  <div class="my-companies-page-container">
    <div v-if="loading" class="flex-all-centered-row" style="font-size: 2.5em;">
      <loading-spinner />
    </div>

    <div class="top-buttons-section">
      <div class="buttons-section">
        <button class="sust-btn sust-btn-green" @click="openInviteSupplierPopup()">
          {{ $t('myCompanies.invite_supplier.button') }}
        </button>
      </div>

      <!-- <div class="buttons-section">
        <button class="sust-btn sust-btn-green" @click="addCompanyModal = true">
          {{ $t('myCompanies.buttons.add') }}
        </button>
      </div> -->
    </div>

    <div class="my-companies-table">
      <div class="my-companies-table-headers">
        <div v-for="header in companyTableHeaders" :key="header.key" id="sust-header-row" :style="{
          flex: header.width,
          textAlign: header.centered ? 'center' : 'left'
        }">
          {{ header.label }}
        </div>
      </div>
      <div class="my-companies-layer layer-1" @click="_getChildrenForCompany(rootCompany)">
        <div v-for="header in companyTableHeaders" :key="header.key" :style="{
          flex: header.width,
          textAlign: header.centered ? 'center' : 'left'
        }">
          <span v-if="header.key === 'created_on' || header.key === 'licence_end_date'">
            {{ rootCompany[header.key] | dateFormat }}
          </span>

          <button v-else-if="header.centered === true" @click.stop="clickCompanyBtn(rootCompany, header.key)">
            <i v-if="header.key === 'delete'" class="fa-regular fa-trash-can"></i>
            <i v-if="header.key === 'link'" class="fa-regular fa-square-plus"></i>
            <i v-if="header.key === 'unlink'" class="fa-regular fa-square-minus"></i>
            <i v-if="header.key === 'users'" class="fa-solid fa-users"></i>
          </button>

          <div class="plan-cell" v-else-if="header.key === 'plan_name'" @click.stop="handleClickPlan(rootCompany)">
            <i v-if="rootCompany.licence_status !== 'ACTIVE'" class="fa-solid fa-triangle-exclamation"
              v-sust-tooltip="{ text: $t('myCompanies.company_table.warnings.inactive_licence'), bgColor: 'var(--invalid-input)' }"></i>
            {{ rootCompany.plan_name }}
          </div>

          <span v-else>
            {{ rootCompany[header.key] || 'N/A' }}
          </span>
        </div>
      </div>

      <div class="child second-child" v-if="rootCompany.is_open">
        <div class="child-inner" v-for="company in companies" :key="company.company_id">
          <div class="my-companies-layer" @click="_getChildrenForCompany(company)">
            <div v-for="header in companyTableHeaders" :key="header.key" :style="{
              flex: header.width,
              textAlign: header.centered == 'delete' ? 'center' : 'left'
            }">
              <span v-if="header.key === 'created_on' || header.key === 'licence_end_date'">
                {{ company[header.key] | dateFormat }}
              </span>

              <button v-else-if="header.centered === true" @click.stop="clickCompanyBtn(company, header.key)">
                <i v-if="header.key === 'delete'" class="fa-regular fa-trash-can"></i>
                <i v-if="header.key === 'link'" class="fa-regular fa-square-plus"></i>
                <i v-if="header.key === 'unlink'" class="fa-regular fa-square-minus"></i>
                <i v-if="header.key === 'users'" class="fa-solid fa-users"></i>
              </button>

              <div class="plan-cell" v-else-if="header.key === 'plan_name'" @click.stop="handleClickPlan(company)">
                <i v-if="company.licence_status !== 'ACTIVE'" class="fa-solid fa-triangle-exclamation"
                  v-sust-tooltip="{ text: $t('myCompanies.company_table.warnings.inactive_licence'), bgColor: 'var(--invalid-input)' }"></i>
                {{ company.plan_name }}
              </div>

              <span v-else>
                {{ company[header.key] || 'N/A' }}
              </span>
            </div>
          </div>

          <div class="child third-child" v-if="company.is_open">
            <div class="child-inner" v-for="_company in company.children" :key="_company.company_id">
              <div class="my-companies-layer" @click="_getChildrenForCompany(_company)">
                <div v-for="header in companyTableHeaders" :key="header.key" :style="{
                  flex: header.width,
                  textAlign: header.centered == 'delete' ? 'center' : 'left'
                }">
                  <span v-if="header.key === 'created_on' || header.key === 'licence_end_date'">
                    {{ _company[header.key] | dateFormat }}
                  </span>

                  <button v-else-if="header.centered === true" @click.stop="clickCompanyBtn(_company, header.key)">
                    <i v-if="header.key === 'delete'" class="fa-regular fa-trash-can"></i>
                    <i v-if="header.key === 'link'" class="fa-regular fa-square-plus"></i>
                    <i v-if="header.key === 'unlink'" class="fa-regular fa-square-minus"></i>
                    <i v-if="header.key === 'users'" class="fa-solid fa-users"></i>
                  </button>

                  <div class="plan-cell" v-else-if="header.key === 'plan_name'" @click.stop="handleClickPlan(_company)">
                    <i v-if="_company.licence_status !== 'ACTIVE'" class="fa-solid fa-triangle-exclamation"
                      v-sust-tooltip="{ text: $t('myCompanies.company_table.warnings.inactive_licence'), bgColor: 'var(--invalid-input)' }"></i>
                    {{ _company.plan_name }}
                  </div>

                  <span v-else>
                    {{ _company[header.key] || 'N/A' }}
                  </span>
                </div>
              </div>

              <div class="child fourth-child" v-if="_company.is_open">
                <div class="child-inner" v-for="__company in _company.children" :key="__company.company_id">
                  <div class="my-companies-layer">
                    <div v-for="header in companyTableHeaders" :key="header.key" :style="{
                      flex: header.width,
                      textAlign: header.centered == 'delete' ? 'center' : 'left'
                    }">
                      <span v-if="header.key === 'created_on' || header.key === 'licence_end_date'">
                        {{ __company[header.key] | dateFormat }}
                      </span>

                      <button v-else-if="header.centered === true" @click.stop="clickCompanyBtn(__company, header.key)">
                        <i v-if="header.key === 'delete'" class="fa-regular fa-trash-can"></i>
                        <i v-if="header.key === 'link'" class="fa-regular fa-square-plus"></i>
                        <i v-if="header.key === 'unlink'" class="fa-regular fa-square-minus"></i>
                        <i v-if="header.key === 'users'" class="fa-solid fa-users"></i>
                      </button>

                      <div class="plan-cell" v-else-if="header.key === 'plan_name'"
                        @click.stop="handleClickPlan(__company)">
                        <i v-if="__company.licence_status !== 'ACTIVE'" class="fa-solid fa-triangle-exclamation"
                          v-sust-tooltip="{ text: $t('myCompanies.company_table.warnings.inactive_licence'), bgColor: 'var(--invalid-input)' }"></i>
                        {{ __company.plan_name }}
                      </div>

                      <span v-else>
                        {{ __company[header.key] || 'N/A' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <sust-popup ref="addCompanyPopup" @ok="createCompany()" @onHide="resetAddCompanyModal"
      :size="addCompanyStep === 3 ? 'xl' : 'md'" :title="$t('myCompanies.buttons.add')" :footer="addCompanyStep === 3">
      <div class="create-company-body">
        <div class="page" v-if="addCompanyStep === 1">
          <div class="half-size">
            <label for="input">
              {{ $t('myCompanies.addCompanySteps.step1') }}
            </label>

            <select name="input" v-model="companyTypeToAdd">
              <option v-for="item in shownCompanyTypes" :value="item" :key="item">
                {{ item.name }}
              </option>
            </select>
          </div>

          <div class="half-size">
            <label for="input">
              {{ $t('myCompanies.addCompanySteps.step1_5') }}
            </label>

            <select name="input" v-model="companyToAdd.plan_id">
              <option v-for="item in allPlans" :value="item.plan_id" :key="item.plan_id">
                {{ item.plan_name }}
              </option>
            </select>
          </div>
        </div>

        <div class="page" v-if="addCompanyStep === 2">
          <div class="full-size">
            <label for="input">
              {{ $t('myCompanies.addCompanySteps.step2') }}
            </label>

            <select name="input" v-model="companyToAddUnder">
              <option v-for="item in companiesToAddUnder" :value="item" :key="item.company_id">
                {{ item.company_name }}
              </option>
            </select>
          </div>
        </div>

        <div class="page" v-if="addCompanyStep === 3">
          <div class="half-size">
            <label for="input">
              {{ $t('companyOperations.modal.company_name') }}
            </label>
            <input type="text" v-model="companyToAdd.company_name">
          </div>
          <div class="half-size">
            <label for="input">
              {{ $t('companyOperations.modal.company_fullname') }}
            </label>
            <input type="text" v-model="companyToAdd.company_fullname">
          </div>

          <div class="half-size">
            <label for="input">
              Website
            </label>
            <input type="text" v-model="companyToAdd.website">
          </div>
          <div class="half-size">
            <label for="input">
              Email
            </label>
            <input type="text" v-model="companyToAdd.company_email">
          </div>

          <div class="half-size">
            <label for="input">
              {{ $t('companyOperations.modal.sector') }}
            </label>
            <select name="input" v-model="companyToAdd.sector_id">
              <option v-for="sector in allSectors" :value="sector.sust_sector_id" :key="sector.sust_sector_id">
                {{ sector.sust_sector_name }}
              </option>
            </select>
          </div>
          <div class="half-size">
            <label for="input">
              {{ $t('companyOperations.modal.phone') }}
            </label>
            <input type="text" v-model="companyToAdd.company_phone">
          </div>

          <div class="half-size">
            <label for="input">
              {{ $t('companyOperations.modal.country') }}
            </label>
            <select name="input" v-model="selectedCountry">
              <option v-for="item in countries" :value="item" :key="item.add_country_id">
                {{ item.add_country_name }}
              </option>
            </select>
          </div>
          <div class="half-size">
            <label for="input">
              <span v-if="!selectedCountry">
                {{ $t('companyOperations.modal.state') }} / {{ $t('companyOperations.modal.province') }}
              </span>
              <span v-else-if="selectedCountry && !selectedCountry.has_state">
                {{ $t('companyOperations.modal.province') }}
              </span>
              <span v-else>
                {{ $t('companyOperations.modal.state') }}
              </span>
            </label>
            <select name="input" v-model="selectedState" :disabled="!selectedCountry">
              <option v-for="item in states" :value="item" :key="item.add_state_id">
                {{ item.add_state_name }}
              </option>
            </select>
          </div>

          <div class="half-size" v-if="selectedCountry && selectedCountry.has_state">
            <label for="input">
              {{ $t('companyOperations.modal.district') }}
            </label>
            <select name="input" v-model="selectedProvince" :disabled="!selectedState">
              <option v-for="item in provinces" :value="item" :key="item.add_province_id">
                {{ item.add_province_name }}
              </option>
            </select>
          </div>

          <div
            :class="{ 'half-size': selectedCountry && selectedCountry.has_state, 'full-size': !selectedCountry || (selectedCountry && !selectedCountry.has_state) }">
            <label for="input">
              {{ $t('companyOperations.modal.address') }}
            </label>
            <textarea type="text" v-model="companyToAdd.adress" rows="3"></textarea>
          </div>

          <div class="half-size">
            <label for="input">
              {{ $t('companyOperations.modal.facility') }}
            </label>
            <input type="number" v-model="companyToAdd.facility_number">
          </div>

          <div class="half-size">
            <label for="input">
              {{ $t('companyOperations.modal.employeeNumber') }}
            </label>
            <input type="number" v-model="companyToAdd.total_employee_number">
          </div>

          <div class="full-size">
            <label for="input">
              {{ $t('companyOperations.modal.description') }}
            </label>
            <textarea type="text" v-model="companyToAdd.description" rows="3"></textarea>
          </div>
        </div>

        <div class="add-company-step-buttons">
          <button :disabled="addCompanyStep === 1" @click="handleStepClick('left')">
            <i class="fa-solid fa-circle-left"></i>
          </button>
          <button
            :disabled="(addCompanyStep == 1 && !(companyTypeToAdd.level && companyToAdd.plan_id)) || (addCompanyStep == 2 && !companyToAddUnder) || addCompanyStep === 3"
            @click="handleStepClick('right')">
            <i class="fa-solid fa-circle-right"></i>
          </button>
        </div>
      </div>
    </sust-popup>

    <sust-popup ref="linkCompanyPopup" @ok="_linkCompany()" @onHide="resetAddCompanyModal" size="md"
      :title="$t('myCompanies.buttons.add')" :footer="addCompanyStepFromTable === 2">
      <div class="create-company-body" v-if="myLevel >= 4">
        <div v-if="addCompanyStepFromTable === 1" class="page">
          <div class="full-size">
            <label for="input">
              {{ $t('myCompanies.addCompanySteps.step1') }}
            </label>
            <select name="input" v-model="companyTypeToAdd" v-if="companyToAddUnderFromTable">
              <option v-for="item in showCompanyTypesFromTable" :value="item" :key="item.level">
                {{ item.name }}
              </option>
            </select>
          </div><!-- 
          <div class="half-size">
            <label for="input">
              {{ $t('myCompanies.addCompanySteps.step1_5') }}
            </label>
            <select name="input" v-model="selectedPlanID">
              <option v-for="item in allPlans"
                :value="item.plan_id"
                :key="item.plan_id"
              >
                {{ item.plan_name }}
              </option>
            </select>
          </div> -->
        </div>

        <div v-if="addCompanyStepFromTable === 2" class="page">
          <div class="full-size">
            <label for="input">
              Company to Link
            </label>
            <select name="input" v-model="companyToLink">
              <option v-for="item in companiesToLink" :value="item" :key="item.company">
                {{ item.company_name }}
              </option>
            </select>
          </div>
        </div>

        <div class="add-company-step-buttons">
          <button :disabled="addCompanyStepFromTable === 1" @click="handleStepClickFromTable('left')">
            <i class="fa-solid fa-circle-left"></i>
          </button>
          <button :disabled="addCompanyStepFromTable === 2 || (addCompanyStepFromTable == 1 && !companyTypeToAdd.level)"
            @click="handleStepClickFromTable('right')">
            <i class="fa-solid fa-circle-right"></i>
          </button>
        </div>
      </div>
    </sust-popup>

    <sust-popup ref="unlinkCompanyPopup" @ok="unlinkCompany()" @onHide="setUnlinkCompany(false, null)" size="sm"
      :title="$t('myCompanies.company_table.warnings.unlink')">
      <div>
        {{ $t('myCompanies.company_table.warnings.unlink_text') }}
      </div>
    </sust-popup>

    <sust-popup ref="companyInfoPopup" @onHide="companyInfoModal = false" size="xl"
      :title="$t('myCompanies.company_table.info')" :footer="false">
      <Stakeholders :companyId="companyIdForInfo" :userInfo="$user" :isAdmin="$user.role_id === 1" />
    </sust-popup>

    <sust-popup ref="companyLicencePopup" @onHide="companyForPlanPopup = null" size="lg"
      :title="$t('myCompanies.company_table.licence')" :footer="false">
      <company-licence :companyId="companyForPlanPopup" :isActive="$user.role_id === 1"
        @update="handlePlanChange($event, rootCompany)" />
    </sust-popup>

    <sust-popup ref="deletePopup" size="sm" :title="$t('userCompany.company.delete_title')" @ok="_deleteCompany()">
      <div>
        {{ $t('userCompany.company.delete_text') }}
      </div>
    </sust-popup>

    <sust-popup ref="inviteSupplierPopup" size="sm" :title="$t('myCompanies.invite_supplier.title')"
      :ok-button-text="$t('myCompanies.invite_supplier.submit')" @ok="submitInviteSupplier()">
      <form class="invite-supplier-form" @submit.prevent="submitInviteSupplier()">
        <div class="invite-supplier-field">
          <span class="invite-supplier-label">{{ $t('myCompanies.invite_supplier.email_label') }}</span>
          <input type="email" required v-model="inviteSupplierEmail"
            :placeholder="$t('myCompanies.invite_supplier.email_placeholder')" />
        </div>
        <div class="invite-supplier-field">
          <span class="invite-supplier-label">{{ $t('myCompanies.invite_supplier.language_label') }}</span>
          <select v-model="inviteSupplierLanguage">
            <option value="en">
              {{ $t('languages.en') }}
            </option>
            <option value="tr">
              {{ $t('languages.tr') }}
            </option>
          </select>
        </div>
      </form>
    </sust-popup>
  </div>
</template>

<style lang="scss">
.invite-supplier-form {
  display: flex;
  flex-direction: column;
  gap: 1em;
  padding: 0.5em 0;

  > .invite-supplier-field {
    display: flex;
    flex-direction: column;
    gap: 0.33em;
    font-size: 0.95em;

    > .invite-supplier-label {
      font-weight: 500;
    }

    > input,
    > select {
      border: 1px solid #ccc;
      border-radius: 0.5em;
      padding: 0.4em 0.66em;
      background-color: white;
    }
  }
}

.my-companies-page-container {
  padding: 2em;

  &>.top-buttons-section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    width: 100%;

    &>.buttons-section {
      display: flex;
      justify-content: flex-end;
      margin-right: 1em;
      margin-bottom: 1em;

      &>.my-companies-top-buttons {
        margin: .66em;
        font-size: 1em !important;
        box-shadow: 0 0 1em .1em gray;
      }
    }
  }
}

.my-companies-table {
  width: 100%;
  border: 0;
  outline: 0;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  >.my-companies-table-headers {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    flex-wrap: wrap;
    align-content: center;

    border-top-left-radius: 1em;
    border-top-right-radius: 1em;
    filter: drop-shadow(0 0 .25em gray);

    background-color: var(--sustainfinity-navy);

    >div {
      padding: .5em;
      color: whitesmoke;
      border-right: thin solid whitesmoke;

      &:last-of-type {
        border-right: 0;
      }
    }
  }

  >.layer-1 {
    width: 100%;
    background-color: whitesmoke;
    color: var(--sustainfinity-navy);
    filter: drop-shadow(0 .1em .15em gray);

    &:hover {
      background-color: lightgray;
    }

    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
  }
}

.child {
  align-self: center !important;
  width: 95% !important;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-bottom-right-radius: 1em;
  border-bottom-left-radius: 1em;

  >.child-inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:last-of-type {
      border-bottom: 0;
      border-bottom-right-radius: 1em;
      border-bottom-left-radius: 1em;
    }
  }
}

.second-child {
  >.child-inner {
    &:last-of-type {
      >.my-companies-layer {
        border-bottom-left-radius: 1em;
        border-bottom-right-radius: 1em;
      }
    }

    >.my-companies-layer {
      width: 100%;
      background-color: rgb(255, 245, 238);
      color: var(--sustainfinity-navy);
      filter: drop-shadow(0 .1em .15em gray);

      &:hover {
        background-color: rgb(242, 228, 219);
      }
    }
  }
}

.third-child {
  >.child-inner {
    &:last-of-type {
      >.my-companies-layer {
        border-bottom-left-radius: 1em;
        border-bottom-right-radius: 1em;
      }
    }

    >.my-companies-layer {
      width: 100%;
      background-color: rgb(201, 225, 223);
      color: var(--sustainfinity-navy);
      filter: drop-shadow(0 .1em .15em gray);

      &:hover {
        background-color: rgb(173, 195, 193);
      }
    }
  }
}

.fourth-child {
  >.child-inner {
    &:last-of-type {
      >.my-companies-layer {
        border-bottom-left-radius: 1em;
        border-bottom-right-radius: 1em;
      }
    }

    >.my-companies-layer {
      width: 100%;
      background-color: rgb(244, 197, 122);
      color: var(--sustainfinity-navy);
      filter: drop-shadow(0 .1em .15em gray);

      cursor: default !important;

      &:hover {
        background-color: rgb(244, 197, 122) !important;
      }
    }
  }
}

.my-companies-layer {
  justify-self: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  align-content: center !important;

  border-bottom: thin solid lightgray;

  transition: background-color 150ms;
  cursor: pointer;

  >div {
    padding: .5em;

    >button {
      border: 0;
      outline: 0;
      width: fit-content;
      padding: .25em;
      background: transparent;

      &:focus {
        outline: thin solid gray !important;
      }

      >i {
        transition: color 150ms;
      }

      >.fa-trash-can {
        color: var(--invalid-input);
      }

      >.fa-square-minus {
        color: var(--sustainfinity-navy);
      }

      >.fa-square-plus {
        color: var(--sustainfinity-green);
      }

      >.fa-users {
        color: var(--sustainfinity-blue);
      }

      &:hover {
        >.fa-trash-can {
          color: var(--invalid-input--hover);
        }

        >.fa-square-minus {
          color: var(--sustainfinity-navy--hover);
        }

        >.fa-square-plus {
          color: var(--sustainfinity-green--hover);
        }

        >.fa-users {
          color: var(--sustainfinity-blue--hover);
        }
      }
    }
  }
}

#sust-header-row {
  border-bottom: 0 !important;
}

#no-data-text {
  text-align: center;
  font-weight: bold;
  font-size: 1.25em;
}

.stakeholders-button {
  color: white;
  background-color: var(--sustainfinity-green);
  border: 0;
  border-radius: 2em;
  padding: .5em;
  min-width: 4em;
  min-height: 1.25em;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  box-shadow: 0 0 .1em .15em white;

  cursor: pointer;

  &:hover {
    background-color: #4ec300;
  }
}

.passive-licence {
  color: rgba(180, 0, 0, 0.6);

  position: absolute;

  top: 50%;
  transform: translateY(-40%);

  left: -.25em;
}

.delete-button {
  color: rgb(180, 0, 0);
  cursor: pointer;

  &:hover {
    color: rgb(255, 55, 0);
  }
}

.add-button {
  color: var(--sustainfinity-green);
  cursor: pointer;

  &:hover {
    color: rgb(64, 203, 0);
  }
}

.disabled-add-button {
  cursor: not-allowed;
  filter: grayscale(100%);
}

.minus-button {
  color: var(--invalid-input);
  cursor: pointer;

  &:hover {
    color: orange;
  }
}

.plan-button {
  position: relative;

  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;

  &:hover {
    filter: brightness(200%);
  }
}

.padding-for-plan-button {
  padding-left: 1em;
}

.add-company-step-button {
  color: var(--sustainfinity-navy);
  font-size: 1.5em;
  cursor: pointer;

  &:hover {
    filter: brightness(150%);
  }

}

.disabled-step-button {
  pointer-events: none;
  color: var(--sustainfinity-navy);
  opacity: .6;
}

.clipboard-button {
  background-color: transparent !important;
  border: 0;
  outline: 0;
  color: var(--sustainfinity-navy) !important;
  padding: 1em !important;
  font-size: 1.5em !important;
  box-shadow: none !important;

  &:focus {
    outline: thin solid gray !important;
  }

  &:active {
    outline: .1em solid gray !important;
  }
}

.disabled-btn {
  background-color: gray !important;
  pointer-events: none !important;
}

.plan-cell {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &:hover {
    font-weight: bold;
    text-decoration: underline;
  }
}

.fa-triangle-exclamation {
  color: var(--invalid-input);
  margin-right: .25em;
}
</style>